<template>
  <div>
    <Vue3Lottie :animationData="animOpts.animationData" class="lottie-anim"/>
  </div>
</template>

<script>

import * as anim from '@/anim/auto/Auto_C.json'
import {Vue3Lottie} from 'vue3-lottie'

export default {
  components: {
    Vue3Lottie
  },
  data: function () {
    return {
      animOpts: { animationData: anim.default }
    }
  }
}
</script>
